/* Bundlekort: legger bundleproduktet (eller begge produktene) i kurven.
   Delegert lytting på dokumentnivå så det virker uansett re-rendring. */
(function () {
  if (window.__pbBundleBound) return;
  window.__pbBundleBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pb-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var ids = (btn.dataset.pbItems || '').split(',').filter(Boolean);
    if (!ids.length) {
      console.warn('[bundle] Ingen variant-IDer på knappen – sjekk produktvalgene i blokken.');
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) {
          return { id: Number(id), quantity: 1 };
        })
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'HTTP ' + res.status);
          });
        }
        window.location.href = btn.dataset.pbCartUrl;
      })
      .catch(function (err) {
        console.error('[bundle] Kunne ikke legge i handlekurven:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Could not add the bundle to the cart: ' + err.message);
      });
  });
})();
